import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getVideoSrc } from '../constants/constants';
import { appSignUp } from '../constants/constants';
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded';

const IntroCreatePlaybooksDragAndDrop = () => {
    const { t, i18n } = useTranslation();
    return (
        <Box
            sx={{
                minHeight: 'auto',
                display: 'flex',
                alignItems: { xs: 'flex-start', md: 'center' },
                justifyContent: 'center',
                p: { xs: 2, md: '160px 32px 0' },
                background: 'url(/images/overlay-1.webp) center/cover no-repeat',
                position: 'relative',
                paddingBottom: { xs: 10, md: 20 },
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    zIndex: 1,
                },
            }}
        >
            <Container
                maxWidth="lg"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4,
                    flexDirection: { xs: 'column', md: 'row' },
                    textAlign: { xs: 'center', md: 'left' },
                    position: 'relative',
                    zIndex: 2,
                }}
            >
                <Box sx={{ flex: 1, minWidth: 300, pt: { xs: 0, md: 4 } }}>
                    <Typography
                        variant="h1"
                        sx={{
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: { xs: '2.9rem', sm: '3.4rem', md: '3.6rem' },
                            fontWeight: 800,
                            lineHeight: 1.2,
                            mb: 3,
                            color: '#1a202c',
                            mt: { xs: 12, sm: 16, md: 0 },
                        }}
                    >
                        {t('IntroCreatePlaybooksDragAndDrop00')}<br />
                        <Box
                            component="span"
                            sx={{
                                background: 'linear-gradient(90deg, #048cec 20%, #fca444 100%)',
                                backgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            }}
                        >
                            {t('IntroCreatePlaybooksDragAndDrop01')}
                        </Box>
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: { xs: '1.15rem', md: '1.3rem' },
                            color: '#4a5568',
                            mb: 4,
                            lineHeight: 1.6,
                            maxWidth: 520,
                            mx: { xs: 'auto', md: 0 },
                            fontWeight: 400,
                            letterSpacing: '0.01em',
                        }}
                    >
                        {t('IntroCreatePlaybooksDragAndDrop02')}
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: { xs: 1, md: 2 }, alignItems: 'center', justifyContent: { xs: 'center', md: 'flex-start' }, flexWrap: 'nowrap' }}>
                        <Button
                            onClick={() => window.location.href = '/playbuilder'}
                            variant="outlined"
                            endIcon={<ArrowOutwardRoundedIcon />}
                            sx={{
                                border: '2px solid #048cec',
                                color: '#048cec',
                                px: { xs: 2, md: 3 },
                                py: { xs: 1, md: 1.25 },
                                fontSize: { xs: '0.8rem', md: '0.85rem' },
                                fontWeight: 600,
                                borderRadius: '8px',
                                textTransform: 'none',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: { xs: 0.5, md: 1 },
                                whiteSpace: 'nowrap',
                                minWidth: 'fit-content',
                                height: { xs: '40px', md: '44px' },
                                backgroundColor: 'transparent',
                                boxShadow: '0 4px 15px rgba(4, 140, 236, 0.2)',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    border: '2px solid #0378c4',
                                    backgroundColor: 'rgba(4, 140, 236, 0.1)',
                                    color: '#0378c4',
                                    boxShadow: '0 6px 20px rgba(4, 140, 236, 0.3)',
                                },
                                '& .MuiButton-endIcon': {
                                    marginLeft: { xs: 0.25, md: 0.5 },
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: { xs: 16, md: 18 },
                                },
                            }}
                        >
                            {t('IntroCreatePractices04')}
                        </Button>
                        <Button
                            onClick={() => window.location.href = appSignUp}
                            variant="contained"
                            sx={{
                                background: '#048cec',
                                color: 'white',
                                px: { xs: 2, md: 3 },
                                py: { xs: 1, md: 1.25 },
                                fontSize: { xs: '0.8rem', md: '0.85rem' },
                                fontWeight: 600,
                                borderRadius: '8px',
                                textTransform: 'none',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: { xs: 0.5, md: 1 },
                                whiteSpace: 'nowrap',
                                minWidth: 'fit-content',
                                height: { xs: '40px', md: '44px' },
                                boxShadow: '0 4px 15px rgba(4, 140, 236, 0.2)',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 20px rgba(4, 140, 236, 0.3)',
                                    background: '#048cec',
                                },
                                '& .MuiButton-endIcon': {
                                    marginLeft: { xs: 0.25, md: 0.5 },
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: { xs: 16, md: 18 },
                                },
                            }}
                        >
                            {t('IntroCreatePractices05')}
                        </Button>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flex: 1,
                        justifyContent: { xs: 'center', md: 'flex-end' },
                        alignItems: 'center',
                        right: { md: '-10%' },
                        mt: { xs: 2, md: 0 },
                    }}
                >
                    <video
                        src={getVideoSrc('intro-create-playbooks-with-drag-and-drop', i18n.language)}
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'contain',
                            borderRadius: 8,
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                        }}
                        aria-label="iCoachBasketball practice customization demo"
                    />
                </Box>
            </Container>
        </Box>
    );
};

export default IntroCreatePlaybooksDragAndDrop;